export default __webpack_public_path__ + "static/media/Reload.cba4525a.png";